window.products = window.products || {};

products.Collection = (function () {
  var selectors = {
    priceFilterSelected: '[data-tag="Price"] .filter-selected',
    productCounter: "[data-product-count]",
    productContainer: "#js-product-loop",
    emptyProductContainer: "#js-empty-products",
    paginationContainer: "#js-pagination-holder",
    countElement: "#js-products-count",
    filterSidebar: "#sidebar-filter",
    filterItem: ".filter-item",
    filterGroup:".filter-group",
    clearFilterElement: ".clear-all",
    accordionHeading: ".js-accordion-heading",
    accordionContent: ".js-accordion-content",
    desktopSort: ".mmc-sort-header",
    desktopSortElements: "#js-sort-desktop li",
    desktopSortSelectedText: "#js-sort-desktop [data-sort-value]",
    mobileSort: "#js-sort-mobile li",
    mobileSortSelectedText: "#js-sort-mobile [data-sort-value]",
    mobileFilterOpener: '[data-action="open-filter"]',
    mobileFilterClose: '[data-action="close-filter"]',
    mobileSortElem: '[data-action="open-sort"]',
    mobilesort_byDrawer: "#js-sort-mobile",
    loader: "#js-loader"
  };

  function Collection(element) {
    this.container = document.querySelector(
      '[data-section-type="' + element + '"]'
    );

    if (!this.container) {
      return;
    }

    this.productsPerAjax = 100; //Number of products to be fetched in one request
    this.allProducts = []; //Will store all the products
    this.totalPage = "";
    this.params = {
      page: 1,
      q: undefined,
      filterOptions: undefined,
      sort_by: undefined,
    };

    this.customFilters = this.initCustomFilters();
    this.options = JSON.parse(
      this.container.getAttribute("data-section-settings")
    );

    //FILL THE PRICE FILTER HIDDEN INPUT DATA-TAG
    if (
      history &&
      history.state &&
      history.state.filterOptions &&
      history.state.filterOptions.price
    ) {
      var priceRange = history.state.filterOptions.price[0];
      if (document.querySelector(".price-filter-item"))
        document.querySelector(".price-filter-item").dataset.tag = priceRange;
    }

    this.initQueryFromUrl();
    this.initCollection();
    this.attachEventListeners();
  }
  

  Collection.prototype.attachEventListeners = function () {
    var _this = this;

    //FILTER SELECTION
    var filterItems = document.querySelectorAll(selectors.filterItem);
    const quickfilterLabels = document.querySelectorAll('.product-type-filterLabel');
    var filterGroups = Array.from(
      document.querySelectorAll(selectors.filterGroup)
    );
    
    for (var filterItem of filterItems) {
      filterItem.addEventListener("click", function () {
        const filterLabel = this.dataset.filterLabel;
        const filterParent = filterGroups.find(
          (item) => item.dataset.tag === filterLabel
        );
    
        this.classList.toggle("filter-selected");
    
        _this.handleFilterChange();
    
        const filterSelectedItems = Array.from(filterItems).filter(item => {
          const filterLabel = item.getAttribute("data-filter-label");
          return item.classList.contains('filter-selected') && filterLabel === 'producttype';
        });
    
        const originalFilterItems = document.querySelectorAll('.filter-group[data-tag="producttype"] .filter-item');
        const quickFilters = document.querySelectorAll('.product-type-filterLabel');
    
        // 1. Collect all normalized hidden product type tags into a Set
        const hiddenProductTypes = new Set();
    
        originalFilterItems.forEach((filterItem) => {
          if (filterItem.classList.contains('hidden')) {
            const dataTags = filterItem.getAttribute('data-tag');
            if (!dataTags) return;
    
            const tagArray = dataTags
              .split(',')
              .map(tag => tag.trim().toLowerCase().replace(/&/g, 'amp').replace(/\s+/g, '-'));
    
            tagArray.forEach(tag => hiddenProductTypes.add(tag));
          }
        });
    
        // 2. Loop through quick filters and disable ones that match hidden items
        quickFilters.forEach((quickFilter) => {
          const quickFilterRaw = quickFilter.getAttribute('data-quick-filter') || '';
          const quickFilterValue = quickFilterRaw
            .toLowerCase()
            .replace(/&/g, 'amp')
            .replace(/\s+/g, '-');
    
          if (hiddenProductTypes.has(quickFilterValue)) {
            quickFilter.classList.add('div-disabled');
          } else {
            quickFilter.classList.remove('div-disabled');
          }
        });
    
        // 3. New: Sync active class for selected product type filters
        const selectedTagSet = new Set();
    
        filterSelectedItems.forEach((x) => {
          const dataTags = x.getAttribute("data-tag");
          if (!dataTags) return;
    
          const tagArray = dataTags
            .split(',')
            .map(tag => tag.trim().toLowerCase().replace(/&/g, 'amp').replace(/\s+/g, '-'));
    
          tagArray.forEach(tag => selectedTagSet.add(tag));
        });
    
        quickFilters.forEach((quickFilter) => {
          const quickFilterRaw = quickFilter.getAttribute('data-quick-filter') || '';
          const quickFilterValue = quickFilterRaw
            .toLowerCase()
            .replace(/&/g, 'amp')
            .replace(/\s+/g, '-');
    
          if (selectedTagSet.has(quickFilterValue)) {
            quickFilter.classList.add('active');
          } else {
            quickFilter.classList.remove('active');
            if (quickFilter.className.includes('active')) {
              quickFilter.className = quickFilter.className.replace(/\bactive\b/, '').trim();
            }
          }
        });
    
      });
    }    
    

    //CLEAR FILTERS
    var clearElements = document.querySelectorAll(selectors.clearFilterElement);
    for (var clearElement of clearElements) {
      clearElement.addEventListener("click", function (event) {
        event.preventDefault();

        document
          .querySelector(selectors.filterSidebar)
          .querySelectorAll(".filter-item")
          .forEach(function (e) {
            e.classList.remove("filter-selected");
          });
        _this.handleFilterChange();

        // Remove active class from all the quick filters
        const quickfilterLabels = document.querySelectorAll('.product-type-filterLabel');
        quickfilterLabels.forEach((quickfilterLabel)=>{
          quickfilterLabel.classList.remove('active')
          quickfilterLabel.classList.remove('div-disabled')
        })
      });
    }

    //DESKTOP SORTING
    let sortHeader = document.querySelector(selectors.desktopSort);

    sortHeader.addEventListener("click", () => {
      document.querySelector(".mmc-sort-list").classList.toggle("hidden");
      document.querySelector(".mmc-sort-desktop").classList.add("hover-effect");
    });

    let searchParams = new URLSearchParams(window.location.search);
    let reqValue = searchParams.get("sort_by");

    var sortElements = document.querySelectorAll(selectors.desktopSortElements);
    
    for (var sortElement of sortElements) {
      sortElement.addEventListener("click", function (event) {
        event.preventDefault();
        sortElement.classList.toggle("is-selected");

        document.querySelector(".mmc-sort-list").classList.add("hidden");
        document
          .querySelector(".mmc-sort-desktop")
          .classList.remove("hover-effect");

        var sortValue = this.getAttribute("data-value");

        _this.params.sort_by = sortValue;
        _this.getProducts(_this.params.page);
        _this.handleFilterChange();
        copyCode();

        document.querySelector(selectors.desktopSortSelectedText).innerHTML =
          this.textContent;
      });
    }

    //MOBILE SORTING
    var mobileSortElements = document.querySelectorAll(selectors.mobileSort);

    // Retaining the last added sort option on page reload:

    for (let i = 0; i < mobileSortElements.length; i++) {      
      if (mobileSortElements[i].getAttribute("data-value") == reqValue) {
        mobileSortElements[i].classList.add("is-selected");
      }
    }

    mobileSortElements.forEach((item) => {
      item.addEventListener("click", (e) => {
        e.preventDefault();

        // Removing the selected class from the previously selected option:
        if (document.querySelectorAll(".is-selected", mobileSortElements)) {
          document
            .querySelectorAll(".is-selected", mobileSortElements)
            .forEach((item) => {
              item.classList.remove("is-selected");
            });
        }

        item.classList.toggle("is-selected");

        let mobileSortValue = item.getAttribute("data-value");
        // console.log(mobileSortValue,'---');
        

        _this.params.sort_by = mobileSortValue;
        _this.getProducts(_this.params.page);
        _this.handleFilterChange();
        copyCode();

        document
          .querySelector(selectors.mobilesort_byDrawer)
          .classList.remove("is--opened");
        document.body.style.overflow = "inherit";
      });
    });

    // Hiding the mmc-sort-list and removing the hover-effect when clicked outside of the element:
    document.addEventListener("click", (event) => {
      if (!document.querySelector(".mmc-sort-desktop").contains(event.target)) {
        document
          .querySelector(".mmc-sort-desktop")
          .classList.remove("hover-effect");
        document.querySelector(".mmc-sort-list").classList.add("hidden");
      }
    });

    //ACCORDION
    var accordionHeadings = document.querySelectorAll(
      selectors.accordionHeading
    );
    for (var accordionHeading of accordionHeadings) {
      accordionHeading.addEventListener("click", function (event) {
        event.preventDefault();
    
        accordionHeadings.forEach((x) => {
          if (x !== this) {
            const content = x.nextElementSibling;
    
            // Only close if the content is visible
            if (window.getComputedStyle(content).display !== "none") {
              x.classList.add("is-closed");
              _this.helpers().slideToggle(content);
            }
          }
        });
    
        this.classList.toggle("is-closed");
        _this.helpers().slideToggle(this.nextElementSibling);
      });
    }      
    //PAGINATION CLICK
    document
      .querySelector(selectors.paginationContainer)
      .addEventListener("click", function (e) {
        e.preventDefault();
        var page = "";

        if (e.target.tagName === "A") {
          page = e.target.getAttribute("data-page");
        } else if (e.target.tagName === "svg" || e.target.tagName === "path") {
          page = e.target.closest("a").getAttribute("data-page");
        }

        _this.helpers().scrollToTop();

        if (page === "") page = "999";
        if (page !== "999") page = parseInt(page);

        if (page != _this.params.page) {
          _this.params.page = page;
          _this.pushState();
          _this.getProducts(page);
        }
      });

    //MOBILE FILTER DRAWER
    var filterOpenElement = document.querySelector(
      selectors.mobileFilterOpener
    );
    filterOpenElement.addEventListener("click", function () {

      let mobileSortDrawer = document.querySelector(selectors.mobilesort_byDrawer);

      if(mobileSortDrawer.classList.contains("is--opened")){
        mobileSortDrawer.classList.remove("is--opened")
      }
      document
        .querySelector(".mmc-main__filter")
        .classList.toggle("is--opened");

      if (
        document
          .querySelector(".mmc-main__filter")
          .classList.contains("is--opened")
      ) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "inherit";
      }
    });

    var filterCloseElements = document.querySelectorAll(
      selectors.mobileFilterClose
    );
    for (var filterCloseElement of filterCloseElements) {
      filterCloseElement.addEventListener("click", function () {
        document
          .querySelector(".mmc-main__filter")
          .classList.remove("is--opened");
        document.body.style.overflow = "inherit";
      });
    }

    //MOBILE SORT DRAWER
    var sort_byOpenElem = document.querySelector(selectors.mobileSortElem);
    sort_byOpenElem.addEventListener("click", function () {
      document
        .querySelector(selectors.mobilesort_byDrawer)
        .classList.toggle("is--opened");
      if (
        document
          .querySelector(selectors.mobilesort_byDrawer)
          .classList.contains("is--opened")
      ) {
        document.body.style.overflow = "hidden";
      } else {
        document.body.style.overflow = "inherit";
      }
    });

    // Price filter checkboxes:
    const priceRanges = [
      "₹501 - ₹750",
      "₹751 - ₹1000",
      "₹1001 - ₹1500",
      "₹1501 - ₹2000",
      "₹2001 - ₹3000",
      "₹3001 & Above",
    ];

    const container = document.querySelector(".filter-group--price-container");

    let checkboxesHTML = priceRanges
      .map(
        (range, index) => `
      <div class="filter-group__listitem price-filter-item filter-item or !tw-flex" name="priceRange" id="price-range-${index}" data-price-range="${range}" data-tag="" data-filter-label="Price">
        <span class="filter-checkbox"></span>
        <span>${range}</span>
      </div>
      <div class="filter-products"></div>
    `
      )
      .join("");

    container.innerHTML = checkboxesHTML;

    document.querySelectorAll('[name="priceRange"]').forEach((item) => {
      item.addEventListener("click", () => {
        let minPrice, maxPrice;
        if (item.getAttribute("data-price-range") == "₹3001 & Above") {
          minPrice = "3001";
          maxPrice = "12000";
        } else {
          minPrice = item
            .getAttribute("data-price-range")
            .split(" - ")[0]
            .replace("₹", "");
          maxPrice = item
            .getAttribute("data-price-range")
            .split(" - ")[1]
            .replace("₹", "");
        }

        let dataTag = minPrice + "-" + maxPrice;

        item.dataset.tag = dataTag;
        item.classList.toggle("filter-selected");
        _this.handleFilterChange();

        const originalFilterItems = document.querySelectorAll('.filter-group[data-tag="producttype"] .filter-item');
        const quickFilters = document.querySelectorAll('.product-type-filterLabel');
    
        // 1. Collect all normalized hidden product type tags into a Set
        const hiddenProductTypes = new Set();
    
        originalFilterItems.forEach((filterItem) => {
          if (filterItem.classList.contains('hidden')) {
            const dataTags = filterItem.getAttribute('data-tag');
            if (!dataTags) return;
    
            const tagArray = dataTags
              .split(',')
              .map(tag => tag.trim().toLowerCase().replace(/&/g, 'amp').replace(/\s+/g, '-'));
    
            tagArray.forEach(tag => hiddenProductTypes.add(tag));
          }
        });
    
        // 2. Loop through quick filters and disable ones that match hidden items
        quickFilters.forEach((quickFilter) => {
          const quickFilterRaw = quickFilter.getAttribute('data-quick-filter') || '';
          const quickFilterValue = quickFilterRaw
            .toLowerCase()
            .replace(/&/g, 'amp')
            .replace(/\s+/g, '-');
    
          if (hiddenProductTypes.has(quickFilterValue)) {
            quickFilter.classList.add('div-disabled');
          } else {
            quickFilter.classList.remove('div-disabled');
          }
        });
      });
    });
  };

  // Copy the coupon code custom component
  class CopyCodeComponent extends HTMLElement {
    constructor() {
      super();
    }
  
    connectedCallback() {
      // Initialize the copy functionality when the component is added to the DOM
      this.copyCode();
    }
  
    copyCode() {
      const imageBlocks = this.querySelectorAll(".image-block");
      if (imageBlocks.length > 0) {
        imageBlocks.forEach((item) => {
          item.addEventListener("click", () => {
            const textToCopy = item.getAttribute("data-coupon-code");
            navigator.clipboard
              .writeText(textToCopy)
              .then(() => {
                const element = document.querySelector(".discount-notification");
                if (element) {
                  element.style.display = "flex";
                  element.textContent = `COUPON CODE copied.`;
                  element.style.animationName = "discountCard";
                  element.style.animationDuration = "1s";
                  element.style.animationTimingFunction = "ease-in-out";
                  setTimeout(() => {
                    element.style.display = "none";
                  }, 1500);
                }
              })
              .catch((err) => {
                console.error("Failed to copy text: ", err);
              });
          });
        });
      }
    }
  }

  // Define the custom element
customElements.define("copy-code-component", CopyCodeComponent);

// Expose the copyCode function for external calls
function copyCode() {
  const elements = document.querySelectorAll("copy-code-component");
  elements.forEach((element) => {
    element.copyCode();
  });
}

  Collection.prototype.initCollection = function () {
    var _this = this,
      queries = [],
      sortUrl = "",
      view = "?view=json&page=",
      numRequests = Math.ceil(this.options.productCount / this.productsPerAjax);

    if (this.params.sort_by) {
      sortUrl = "&sort_by=" + this.params.sort_by;
    }

    for (var page = 1; page <= numRequests; page++) {
      queries.push(fetch(location.pathname + view + page + sortUrl));
    }

    if (!queries.length) {
      console.error(
        "Nothing to fetch!! Either you forgot to add .json template or the current page type doesn't have any products."
      );
      return;
    }

    Promise.all(queries).then(function (responses) {
      Promise.all(
        responses.map(function (response) {
          return response.json();
        })
      ).then(function (productsArray) {
        for (var i = 0; i < productsArray.length; i++) {
          var products = productsArray[i];

          for (var j = 0; j < products.length; j++) {
            _this.allProducts.push(products[j]);
          }
        }
        _this.originalProducts = [..._this.allProducts];

        _this.htmlRenderer().renderFilters(_this.allProducts);
        _this.getProducts(_this.params.page);
        copyCode();


        // Getting the number of products for each filter:
        let items = document.querySelectorAll(selectors.filterItem);
        const quickfilterLabels = document.querySelectorAll('.product-type-filterLabel');
        const carouselComponent = document.querySelector('carousel-component.product-type-filter-slider')

        items.forEach((item) => {
          if (item.getAttribute("data-tag")) {
            let filterLabel = item.getAttribute("data-filter-label");
            let filterTag = [item.getAttribute("data-tag")];
            let reqParam = {
              [filterLabel]: filterTag,
            };
            let products = _this
              .filterHelpers()
              .filterProducts(_this.allProducts, reqParam);

            const quantityContainer = item.querySelector(".filter-products");            
            
            
            if (products.length == 0) { 
              item.classList.add("hidden"); 
              quickfilterLabels.forEach((quickfilterLabel) => {
                const quickFilterValue = quickfilterLabel
                .getAttribute('data-quick-filter')
                ?.toLowerCase()
                .replace(/&/g, 'amp') // Replace & with 'amp'
                .replace(/\s+/g, '-'); // Replace spaces with dashes
              

                  if (filterTag[0] === quickFilterValue) {
                    quickfilterLabel.closest('li').remove();
                    carouselComponent.refreshSlider();
                  }
              });              
            } else {
              quantityContainer.innerHTML = "(" + products.length + ")";
            }
          }
        });

        // Hide parent .filter-group if all its children .filter-group__listitem are hidden
        document.querySelectorAll(".filter-group").forEach((group) => {
          let listItems = group.querySelectorAll(".filter-group__listitem");
          let allHidden = Array.from(listItems).every(item => item.classList.contains("hidden"));

          if (allHidden) {
            group.classList.add("hidden");
          }
        });
      });
    });
    // allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
    // HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
  };

  Collection.prototype.getProducts = function (pageNumber) {
    var _this = this,
      priceRanges = [],
      getProducts = [],
      filteredProducts = this.filterHelpers().filterProducts(
        this.allProducts,
        this.params.filterOptions
      );

    /* EXCLUDE OUT OF STOCK PRODUCTS */
    if (this.options.excludeOosProducts) {   
      getProducts = filteredProducts.filter(function (p) {
        return p.available;
      });
    } else {
      getProducts = filteredProducts;
    }

    this.sortProducts(getProducts);
    this.totalPage = Math.ceil(
      getProducts.length / this.options.productPerPage
    );

    /* SHOW OUT OF STOCK PRODUCTS ON LAST */
    if (this.options.showOosLast) {
      getProducts.sort(function (a, b) {
        return b.available - a.available;
      });
    }

    this.filterHelpers().hideFilterOptions()


    if (document.querySelector(selectors.countElement)) {
      document.querySelector(selectors.countElement).innerHTML =
        "Showing " + getProducts.length + " products";
    }

    if (getProducts.length > 0 && pageNumber) {
      if (pageNumber !== "999" && pageNumber > this.totalPage) pageNumber = 1;

      document.querySelector(selectors.loader).classList.remove("hidden");
      document.body.classList.add(".mmc-overflow-hidden")

      var productGrid = "",
        endIndex =
          getProducts.length < pageNumber * this.options.productPerPage ||
          pageNumber === "999"
            ? getProducts.length
            : pageNumber * this.options.productPerPage,
        startIndex =
          pageNumber === "999" || endIndex < this.options.productPerPage
            ? 0
            : (pageNumber - 1) * this.options.productPerPage;

      const desktopBannerImage = document
        .querySelector(".mmc-container")
        .getAttribute("data-desktop-image");
      const mobileBannerImage = document
        .querySelector(".mmc-container")
        .getAttribute("data-mobile-banner");

      const desktopImages = document
        .querySelector(".mmc-container")
        .getAttribute("data-desktop-images")
        .split(",");
      const mobileImages = document
        .querySelector(".mmc-container")
        .getAttribute("data-mobile-images")
        .split(",");
      const couponCode = document
        .querySelector(".mmc-container")
        .getAttribute("data-coupon-codes")
        .split(",");

      const bannerHeading = document
        .querySelector(".mmc-container")
        .getAttribute("data-banner-heading");

      let desktopImageContainer = "";

      let mobileImageContainer = "";


      if(desktopImages.length > 2){
          // Keeping this logic for the condition where less than 3 or no creatives are entered, can be removed with something better:
        for (i = 0; i < desktopImages.length; i++) {
          desktopImageContainer += `<copy-code-component><img src=${desktopImages[i]} alt="Desktop image block" class="desktop-image-block image-block tw-cursor-pointer" data-coupon-code="${couponCode[i]}"/></copy-code-component>`;
  
          mobileImageContainer += `<copy-code-component><img src=${mobileImages[i]} alt="Mobile image block" class="mobile-image-block image-block tw-cursor-pointer" data-coupon-code="${couponCode[i]}"/></copy-code-component>`;
        }
      }

      const desktopBanner = `<div class='desktop-banner banner-image tw-items-center tw-w-full tw-justify-center tw-relative' style="background-image: url('${desktopBannerImage}')">
                            <div class='banner-heading tw-text-center tw-text-red-600 tw-mb-2 tw-uppercase'>${bannerHeading}</div>
                            <div class='banner-image-container'>${desktopImageContainer}</div>
                            </div> `;

      const tabletBanner = `<div class='tablet-banner banner-image tw-items-center tw-w-full tw-justify-center tw-relative' style="background-image: url('${desktopBannerImage}')">
                            <div class='banner-heading tw-text-center tw-text-red-600 tw-mb-2 tw-uppercase'>${bannerHeading}</div>
                            <div class='banner-image-container'>${desktopImageContainer}</div>
                          </div> `;

      const mobileBanner = `<div class='mobile-banner banner-image tw-items-center tw-w-full tw-justify-center tw-relative' style="background-image: url('${mobileBannerImage}')">
                            <div class='banner-heading tw-text-center tw-text-red-600 tw-mb-2 tw-uppercase'>${bannerHeading}</div>
                            <div class='banner-image-container'>${mobileImageContainer}</div>
                          </div> `;

      for (var i = startIndex; i < endIndex; i++) {
        if (i > 0 && i % 12 === 0) {
          productGrid += desktopBanner;
        }
        if (i > 0 && i % 9 === 0) {
          productGrid += tabletBanner;
        }
        if (i > 0 && i % 6 === 0) {
          productGrid += mobileBanner;
        }
        productGrid += _this.htmlRenderer().renderProduct(i, getProducts[i]);
      }

      document.body.classList.remove(".mmc-overflow-hidden")
      document.querySelector(selectors.loader).classList.add("hidden");

      this.generatePagination(pageNumber);
      document
        .querySelector(selectors.productContainer)
        .classList.remove("is-hidden");
      document
        .querySelector(selectors.emptyProductContainer)
        .classList.add("is-hidden");
        
      if (
        this.options.paginationType == "infinite_scroll" &&
        pageNumber !== 1
      ) {
        document.querySelector(selectors.loader).classList.remove("hidden")
        document.body.classList.add(".mmc-overflow-hidden")
        document.querySelector(selectors.productContainer).innerHTML +=
          productGrid;
        document.querySelector(selectors.loader).classList.add("hidden");
        document.body.classList.remove(".mmc-overflow-hidden")
      } else {
        document.querySelector(selectors.productContainer).innerHTML =
          productGrid;
      }
    } else {
      document.querySelector(selectors.productContainer).innerHTML = "";
      document
        .querySelector(selectors.productContainer)
        .classList.add("is-hidden");
      document
        .querySelector(selectors.paginationContainer)
        .classList.add("is-hidden");
      document
        .querySelector(selectors.emptyProductContainer)
        .classList.remove("is-hidden");
    }

    if (pageNumber >= this.totalPage) {
      const elementsToShow = [
        '.plp-seoText',
        '.plp-popularSearch',
        '.plp-newsLetter',
        '.plp-footer',
        '.plp-footerBottom'
      ];
      document.querySelector(selectors.emptyProductContainer).classList.add('hidden');
      elementsToShow.forEach(selector => document.querySelector(selector).classList.remove('hidden'));
    } 

    if (getProducts.length == 0) {
      document.querySelector('.empty-products-text').classList.remove('hidden')
    }else{
      document.querySelector('.empty-products-text').classList.add('hidden')
    }
  }


  Collection.prototype.generatePagination = function (currentPage) {
    var _this = this;

    if (this.totalPage <= 1) {
      document
        .querySelector(selectors.paginationContainer)
        .classList.add("is-hidden");
      return;
    }

    var paginationHtml = "";
    if (currentPage !== "999") {
      paginationHtml +=
        (currentPage - 1 >= 1
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage - 1) +
            '" class="pagination__item" rel="prev" title="Previous page" data-page="' +
            (currentPage - 1) +
            '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M3.00293 8.00004C3.00913 8.19072 3.08671 8.37972 3.23612 8.5254L9.64155 14.772C9.95238 15.076 10.4574 15.076 10.7691 14.772C11.0809 14.4689 11.0809 13.9764 10.7691 13.6724L4.95256 8.00001L10.7691 2.32764C11.0809 2.02362 11.0809 1.53114 10.7691 1.22802C10.4574 0.923993 9.95238 0.923993 9.64155 1.22802L3.23615 7.47462C3.08674 7.62033 3.00916 7.8093 3.00293 8.00001L3.00293 8.00004Z" fill="black"/></svg></a>'
          : "") +
        (currentPage !== 1
          ? '<a href="' +
            this.options.collectionUrl +
            '?page=1" class="pagination__item" title="Navigate to page 1" data-page="1">1</a>'
          : "") +
        (currentPage >= 4 ? "…" : "") +
        (currentPage - 2 > 1
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage - 2) +
            '" class="pagination__item" title="Navigate to page ' +
            (currentPage - 2) +
            '" data-page="' +
            (currentPage - 2) +
            '">' +
            (currentPage - 2) +
            "</a>"
          : "") +
        (currentPage - 1 > 1
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage - 1) +
            '" class="pagination__item" title="Navigate to page ' +
            (currentPage - 1) +
            '" data-page="' +
            (currentPage - 1) +
            '">' +
            (currentPage - 1) +
            "</a>"
          : "") +
        '<span class="pagination__item pagination__item--current">' +
        currentPage +
        "</span>" +
        (currentPage + 1 < this.totalPage
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage + 1) +
            '" class="pagination__item" title="Navigate to page ' +
            (currentPage + 1) +
            '" data-page="' +
            (currentPage + 1) +
            '">' +
            (currentPage + 1) +
            "</a>"
          : "") +
        (currentPage + 2 < this.totalPage
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage + 2) +
            '" class="pagination__item" title="Navigate to page ' +
            (currentPage + 2) +
            '" data-page="' +
            (currentPage + 2) +
            '">' +
            (currentPage + 2) +
            "</a>"
          : "") +
        (currentPage <= this.totalPage - 4 ? "…" : "") +
        (currentPage !== this.totalPage
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            this.totalPage +
            '" class="pagination__item" title="Navigate to page ' +
            this.totalPage +
            '" data-page="' +
            this.totalPage +
            '">' +
            this.totalPage +
            "</a>"
          : "") +
        (currentPage + 1 <= this.totalPage
          ? '<a href="' +
            this.options.collectionUrl +
            "?page=" +
            (currentPage + 1) +
            '" class="pagination__item" rel="next" title="Next page" data-page="' +
            (currentPage + 1) +
            '"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none"><path d="M13 8C12.9938 7.80932 12.9162 7.62035 12.7668 7.47461L6.36138 1.22802C6.05055 0.923993 5.54555 0.923993 5.2338 1.22802C4.92207 1.53114 4.92207 2.02364 5.2338 2.32764L11.0504 8L5.2338 13.6724C4.92207 13.9764 4.92207 14.4689 5.2338 14.772C5.54555 15.076 6.05053 15.076 6.36138 14.772L12.7668 8.52539C12.9162 8.37968 12.9938 8.19068 13 8Z" fill="black"/></svg></a>'
          : "");
    }
    paginationHtml +=
      '<a href="' +
      this.options.collectionUrl +
      "?page=" +
      (currentPage === "999" ? "1" : "999") +
      '" class="pagination__item" title="' +
      (currentPage === "999" ? "View Less" : "View All") +
      '" data-page="' +
      (currentPage === "999" ? "1" : "") +
      '">' +
      (currentPage === "999" ? "View Less" : "View All") +
      "</a>";
    paginationHtml += '<div class="infinite-scroll-element"></div>';

    document.querySelector(selectors.paginationContainer).innerHTML =
      paginationHtml;

    if (this.options.paginationType == "infinite_scroll") {
      document
        .querySelector(selectors.paginationContainer)
        .classList.add("is-hidden");
      const infiniteScroll = document.querySelector(".infinite-scroll-element"),
        io = new IntersectionObserver((e) => {
          e[0].intersectionRatio <= 0 ||
            _this.totalPage <= currentPage ||
            _this.getProducts(currentPage + 1);
        });
      io.observe(infiniteScroll);
    } else {
      document
        .querySelector(selectors.paginationContainer)
        .classList.remove("is-hidden");
    }
  };

  Collection.prototype.initQueryFromUrl = function () {
    var queryString = this.helpers().generateQuery();

    if (queryString.q) {
      this.params.q = queryString.q;
    }
    if (queryString.sort_by) {
      this.params.sort_by = queryString.sort_by;
    }
    if (queryString.page) {
      this.params.page = parseInt(queryString.page);
    }

    if (this.params.q) {
      this.params.q = decodeURI(this.params.q);

      this.filterHelpers().searchToFilter(this.params.q.split(","));
      this.handleFilterChange();
    }

    if (this.params.filterOptions) {
      this.filterHelpers().setFilterOptions(this.params);
    }
  };

  Collection.prototype.sortProducts = function (products) {
  var e = 0;

  // === NEW: Handle "featured" or no sort_by ===
// if (
//   !this.params.sort_by ||
//   this.params.sort_by === "featured" ||
//   this.params.sort_by === "manual"
// ) {
//   if (this.originalProducts) {
//     products.length = 0;
//     this.originalProducts.forEach(p => products.push(p));
//   }
//   return products;
// }
  // ============================================
    

  if (this.params.sort_by == "title-descending")
    e = function (b, a) {
      return a.title.localeCompare(b.title);
    };
  else if (this.params.sort_by == "title-ascending")
    e = function (a, b) {
      return a.title.localeCompare(b.title);
    };
  else if (this.params.sort_by == "price-ascending")
    e = function (a, b) {
      return a.price - b.price;
    };
  else if (this.params.sort_by == "price-descending")
    e = function (b, a) {
      return a.price - b.price;
    };
  else if (this.params.sort_by == "created-ascending")
    e = function (a, b) {
      return a.published_at > b.published_at
        ? -1
        : a.published_at == b.published_at
        ? a.title.localeCompare(b.title)
        : 1;
    };
  else if (this.params.sort_by == "created-descending")
    e = function (b, a) {
      return a.published_at > b.published_at
        ? 1
        : a.published_at == b.published_at
        ? a.title.localeCompare(b.title)
        : -1;
    };
  else if (this.params.sort_by == "discount-ascending")
    e = function (a, b) {
      return (
        Number.parseFloat(a.metafields.discountrange || 0) -
        Number.parseFloat(b.metafields.discountrange || 0)
      );
    };
  else if (this.params.sort_by == "discount-descending")
    e = function (b, a) {
      return (
        Number.parseFloat(a.metafields.discountrange || 0) -
        Number.parseFloat(b.metafields.discountrange || 0)
      );
    };
  else if (this.params.sort_by == "best-selling")
    e = function (a, b) {
      const aIsBestseller = a.tags.includes("bestseller");
      const bIsBestseller = b.tags.includes("bestseller");
      if (aIsBestseller && !bIsBestseller) return -1;
      if (!aIsBestseller && bIsBestseller) return 1;
      return 0;
    };

  if (e) {
    return products.sort(e);
  }

  return products;
};

  Collection.prototype.pushState = function () {
    var a = {},
      p = !1,
      _this = this,
      path = location.pathname,
      searchParams = new URLSearchParams();

    1 != _this.params.page && ((a.page = _this.params.page), (p = 1)),
      _this.params.sort_by &&
        _this.params.q &&
        ((a.sort_by = _this.params.sort_by), (a.q = _this.params.q), (p = 1)),
      _this.params.q && ((a.q = _this.params.q), (p = 1)),
      _this.params.sort_by && ((a.sort_by = _this.params.sort_by), (p = 1));

    if (a.q) {
      a.q = decodeURI(a.q);
    }

    Object.keys(a).forEach(function (key) {
      searchParams.append(key, a[key]);
    });
    p && (path = "?" + searchParams.toString()),
      history.pushState(
        {
          filterOptions: _this.params.filterOptions,
        },
        " ",
        path
      );
  };

  Collection.prototype.handleFilterChange = function () {
    var _this = this;

    _this.params.filterOptions = _this.filterHelpers().fillFilter();

    if (_this.params.page !== "999") _this.params.page = 1;
    _this.getProducts(_this.params.page);

    var query = Object.keys(_this.params.filterOptions)
      .map(function (o) {
        return _this.params.filterOptions[o]
          .map(function (o) {
            return encodeURIComponent(o);
          })
          .join(",");
      })
      .join(",");

    if (query) {
      query = location.pathname + "?q=" + query;

      if (_this.params.sort_by) {
        query += "&sort_by=" + _this.params.sort_by;
      }
    } else {
      query = location.pathname;

      if (_this.params.sort_by) {
        query += "?sort_by=" + _this.params.sort_by;
      }
    }

    history.replaceState(_this.params, "Filtered", query);
    copyCode();
  };

  /*
   * HELPER FUNCTIONS FOR FILTERING
   */
  Collection.prototype.filterHelpers = function () {
    var _this = this,
      sidebarFilter = document.querySelector(selectors.filterSidebar);

    return {
      filterProducts: function (data, filters) {   
        var output = [];
        if (filters && Object.keys(filters).length)
          for (var i = 0; i < data.length; i++)
            _this.helpers().productTagFilter(filters, data[i]) &&
              output.push(data[i]);
        else output = data;
        return output;
      },
      fillFilter: function () {
        var andtags = {};

        document.querySelectorAll(".and", sidebarFilter).forEach(function (a) {
          var t = [];
          a.querySelectorAll(".or.filter-selected").forEach(function (a) {
            t.push(_this.helpers().getTagName(a));
          }),
            t.length && (andtags[a.getAttribute("data-tag")] = t);
        });
        return andtags;
      },
      searchToFilter: function (arr) {
        document.querySelectorAll(".and", sidebarFilter).forEach(function (a) {
          a.querySelectorAll(".or").forEach(function (a) {
            -1 !== arr.indexOf(_this.helpers().getTagName(a)) &&
              a.classList.add("filter-selected");
          });
        });
      },
      setFilterOptions: function (filters) {
        document.querySelectorAll(".and", sidebarFilter).forEach(function (a) {
          var e = a.getAttribute("data-tag");
          var i = filters[e];

          i &&
            i.length &&
            a.querySelectorAll(".or").forEach(function (a) {
              i.indexOf(
                _this.helpers().handleize(a.getAttribute("data-tag")) ||
                  _this.helpers().handleize(a.textContent).trim()
              ) >= 0 && a.classList.add("filter-selected");
            });
        });
      },
      hideFilterOptions: function () {
        const filterItems = document.querySelectorAll(selectors.filterItem);
        const filterGroups = document.querySelectorAll('.filter-group');
      
        const activeFilters = _this.params.filterOptions || {};
        const excludeOos = _this.options.excludeOosProducts;
        const allProducts = _this.allProducts;
      
        // Precompute base products once per unique filter group
        const baseProductCache = {};
      
        filterItems.forEach(item => {
          const tagName = _this.helpers().getTagName(item);
          const filterLabel = _this.helpers().getFilterLabel(item);
      
          const parentElement = item.closest('.filter-group'); // faster than querySelector with attribute
      
          // Skip if already cached
          if (!baseProductCache[filterLabel]) {
            const currentFilters = { ...activeFilters };
            delete currentFilters[filterLabel];
      
            let baseProducts = _this.filterHelpers().filterProducts(allProducts, currentFilters);
            if (excludeOos) {
              baseProducts = baseProducts.filter(p => p.available);
            }
      
            baseProductCache[filterLabel] = baseProducts;
          }
      
          const baseProducts = baseProductCache[filterLabel];
          const testFilter = { [filterLabel]: [tagName] };
      
          const available = baseProducts.some(product =>
            _this.helpers().productTagFilter(testFilter, product)
          );
      
          item.classList.toggle("hidden", !available);
        });
      
        // Hide groups where all children are hidden
        filterGroups.forEach(group => {
          const filterItems = group.querySelectorAll('.filter-item');
          const allHidden = Array.from(filterItems).every(item =>
            item.classList.contains('hidden')
          );
          group.classList.toggle('hidden', allHidden);
        });
      }        
      
    };
  };

  /*
   * TINY HELPERS FUNCTIONS
   */
  Collection.prototype.helpers = function () {
    var _this = this;

    return {
      handleize: function (string) {
        return string
          .toLowerCase()
          .replace(/[^a-z0-9]+/g, "-")
          .replace(/-$/, "")
          .replace(/^-/, "");
      },
      scrollToTop: function () {
        window.scrollTo({ top: 0, behavior: "smooth" });
      },
      generateQuery: function () {
        var url = window.location.href;
        var urlParams = url.split("?"),
          queryArray = [];

        if (urlParams.length != 2) {
          return queryArray;
        }

        var splitUrl = urlParams[1].split("&");
        for (var i = 0; i < splitUrl.length; i++) {
          var splitEqual = splitUrl[i].split("=");
          queryArray[splitEqual[0]] = splitEqual[1];
        }
        return queryArray;
      },
      getTagName: function (element) {
        return (
          _this.helpers().handleize(element.getAttribute("data-tag")) ||
          _this.helpers().handleize(element.textContent).trim()
        );
      },
      getFilterLabel: function (element){
        return(
          _this.helpers().handleize(element.getAttribute("data-filter-label"))
        )
      },
      basicSearch: function (ortags, classes) {
        var or = false;

        classes = classes.map(function (c) {
          return _this.helpers().handleize(c);
        });

        if ("object" == typeof ortags) {
          Object.keys(ortags).forEach(function (item) {
            if (classes.indexOf(ortags[item]) > -1) return (or = !0), !1;
          });
        } else {
          [ortags].forEach(function (items) {
            Object.keys(items).forEach(function (item) {
              if (classes.indexOf(items[item]) > -1) return (or = !0), !1;
            });
          });
        }
        return or;
      },
      basicTagSearch: function (ortags, object) {
        return object.tags
          ? _this.helpers().basicSearch(ortags, object.tags)
          : false;
      },
      productTagFilter: function (filters, object) {
        var and = true;

        Object.keys(filters).forEach(function (ortags) {
          if (and && filters[ortags] && filters[ortags].length) {
            and =
              and &&
              (_this.customFilters[ortags]
                ? _this.customFilters[ortags](filters[ortags], object)
                : _this.helpers().basicTagSearch(filters[ortags], object));
          }
          return and;
        });
        return and;
      },
      compareRanges: function (r, n) {
        for (var e = 0; e < n.length; e++)
          if (r >= n[e][0] && r <= n[e][1]) return !0;
        return !1;
      },
      formatMoney: function (cents, format) {
        var moneyFormat = "₹{{amount_no_decimals}}";

        if (typeof cents === "string") {
          cents = cents.replace(".", "");
        }
        var value = "";
        var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
        var formatString = format || moneyFormat;

        function formatWithDelimiters(number, precision, thousands, decimal) {
          thousands = thousands || ",";
          decimal = decimal || ".";

          if (isNaN(number) || number === null) {
            return 0;
          }

          number = (number / 100.0).toFixed(precision);

          var parts = number.split(".");
          var dollarsAmount = parts[0].replace(
            /(\d)(?=(\d\d\d)+(?!\d))/g,
            "$1" + thousands
          );
          var centsAmount = parts[1] ? decimal + parts[1] : "";

          return dollarsAmount + centsAmount;
        }

        switch (formatString.match(placeholderRegex)[1]) {
          case "amount":
            value = formatWithDelimiters(cents, 2);
            break;
          case "amount_no_decimals":
            value = formatWithDelimiters(cents, 0);
            break;
          case "amount_with_comma_separator":
            value = formatWithDelimiters(cents, 2, ".", ",");
            break;
          case "amount_no_decimals_with_comma_separator":
            value = formatWithDelimiters(cents, 0, ".", ",");
            break;
          case "amount_no_decimals_with_space_separator":
            value = formatWithDelimiters(cents, 0, " ");
            break;
          case "amount_with_apostrophe_separator":
            value = formatWithDelimiters(cents, 2, "'");
            break;
        }

        return formatString.replace(placeholderRegex, value);
      },
      slideToggle: function (target, duration = 300) {
        //TODO:: FIND A BETTER SOLUTION FOR THIS
        function slideUp(e, t = 500) {
          (e.style.transitionProperty = "height, margin, padding"),
            (e.style.transitionDuration = t + "ms"),
            (e.style.boxSizing = "border-box"),
            (e.style.height = e.offsetHeight + "px"),
            e.offsetHeight,
            (e.style.overflow = "hidden"),
            (e.style.height = 0),
            (e.style.paddingTop = 0),
            (e.style.paddingBottom = 0),
            (e.style.marginTop = 0),
            (e.style.marginBottom = 0),
            window.setTimeout(function () {
              (e.style.display = "none"),
                e.style.removeProperty("height"),
                e.style.removeProperty("padding-top"),
                e.style.removeProperty("padding-bottom"),
                e.style.removeProperty("margin-top"),
                e.style.removeProperty("margin-bottom"),
                e.style.removeProperty("overflow"),
                e.style.removeProperty("transition-duration"),
                e.style.removeProperty("transition-property");
            }, t);
        }
        function slideDown(e, t = 500) {
          e.style.removeProperty("display");
          let o = window.getComputedStyle(e).display;
          "none" === o && (o = "block"), (e.style.display = o);
          let r = e.offsetHeight;
          (e.style.overflow = "hidden"),
            (e.style.height = 0),
            (e.style.paddingTop = 0),
            (e.style.paddingBottom = 0),
            (e.style.marginTop = 0),
            (e.style.marginBottom = 0),
            e.offsetHeight,
            (e.style.boxSizing = "border-box"),
            (e.style.transitionProperty = "height, margin, padding"),
            (e.style.transitionDuration = t + "ms"),
            (e.style.height = r + "px"),
            e.style.removeProperty("padding-top"),
            e.style.removeProperty("padding-bottom"),
            e.style.removeProperty("margin-top"),
            e.style.removeProperty("margin-bottom"),
            window.setTimeout(function () {
              e.style.removeProperty("height"),
                e.style.removeProperty("overflow"),
                e.style.removeProperty("transition-duration"),
                e.style.removeProperty("transition-property");
            }, t);
        }

        if (window.getComputedStyle(target).display === "none") {
          return slideDown(target, duration);
        } else {
          return slideUp(target, duration);
        }
      },
      productTagFilter: function (filters, object) {
        var and = true;

        Object.keys(filters).forEach(function (ortags) {
          if (and && filters[ortags] && filters[ortags].length) {
            and =
              and &&
              (_this.customFilters[ortags]
                ? _this.customFilters[ortags](filters[ortags], object)
                : _this.helpers().basicTagSearch(filters[ortags], object));
          }
          return and;
        });
        return and;
      }
    };
  };

  /*
   * DEFAULT CUSTOM FILTERS
   */
  Collection.prototype.initCustomFilters = function () {
    var _this = this;

    return {
      availability: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (tag == "in-stock" && product.available) or = true;
          if (tag == "out-of-stock" && !product.available) or = true;
        });
        return or;
      },
      brand: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.vendor &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.vendor)
          )
            or = true;
        });
        return or;
      },
      size: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          product.variants.forEach(function (variant) {
            if (
              (variant.option1 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option1) &&
                variant.available) ||
              (variant.option2 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option2) &&
                variant.available) ||
              (variant.option3 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option3) &&
                variant.available)
            ) {
              or = true;
            }
          });
        });
        return or;
      },
      color: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          product.variants.forEach(function (variant) {
            if (
              (variant.available &&
                variant.option1 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option1)) ||
              (variant.available &&
                variant.option2 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option2)) ||
              (variant.available &&
                variant.option3 &&
                _this.helpers().handleize(tag) ==
                  _this.helpers().handleize(variant.option3))
            ) {
              or = true;
            }
          });
        });
        return or;
      },
      price: function (ortags, product) {
        var or = false,
          prices = [];

        ortags.filter(function (tag) {
          prices.push(tag.split("-"));

          if (_this.helpers().compareRanges(product.price / 100, prices))
            or = true;
        });
        return or;
      },
      producttype: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.type &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.type) &&
            product.available
          )
            or = true;
        });
        return or;
      },
      gsm: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.metafields.gsm &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.metafields.gsm) &&
            product.available
          )
            or = true;
        });
        return or;
      },
      productweight: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.metafields.productweight &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.metafields.productweight) &&
              product.available
          )
            or = true;
        });
        return or;
      },
      threadcount: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.metafields.threadcount &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.metafields.threadcount) &&
            product.available
          )
            or = true;
        });
        return or;
      },
      discountrange: function (ortags, product) {
        var or = false;

        ortags.filter(function (tag) {
          if (
            product.metafields.discountrange &&
            _this.helpers().handleize(tag) ==
              _this.helpers().handleize(product.metafields.discountrange) &&
            product.available
          )
            or = true;
        });
        return or;
      },
    };
  };

  /*
   * CREATE FILTER & PRODUCT CARDS HTML
   */
  Collection.prototype.htmlRenderer = function () {
    var _this = this;

    return {
      /*
       * The idea is to generate filter sidebar through JS to make it faster
       * Liquid is slow when you've infinite products
       */
      renderFilters: function (products) {
        let filters = products.reduce(function (a, p) {
          return a;
        }, []);
      },
      renderProduct: function (index, product) {
        var productHtml = "";

        var image_space = 100;
        if (product.featured_image) {
          var splitImage = product.featured_image.split(".");
          splitImage[splitImage.length - 2] =
            splitImage[splitImage.length - 2] + "_360x";

          var product_image = splitImage.join(".");
          image_space = 100;
        }

        // setTimeout(() => {
        //   allHulkWishlistButtons = Array.from(document.querySelectorAll('[data-wishlist]'));
        //   HulkappWishlist._checkForProductStatus(allHulkWishlistButtons, 'multiple');
        // }, 2000);

        // Parse Wishlist JSON Data
        const wishlistData = JSON.parse(document.getElementById('wishlist-data').textContent);

        productHtml += `
        <marmeto-product-card 
        class="product-card grid__item tw-flex tw-flex-col tw-justify-center tw-group/product-card hover:tw-cursor-pointer hover:tw-shadow-xl tw-p-2 tw-pb-4" data-product-handle=${
          product.handle
        }>
        <div class="tw-isolate tw-relative">
          <popup-info>
            <div class="product_card-image tw-relative tw-group/item">
                  ${
      product.tags.includes("Designer's Edit")
        ? `<div class="lebeltagtext z-1 tw-absolute tw-top-2 tw-left-2 tw-bg-blue-600 tw-text-white tw-text-xs tw-font-semibold tw-px-2 tw-py-1 tw-rounded" style="z-index:1; background:#028677; text-transform:uppercase; font-size:12px; margin-top:5px;">Designer’s Edit</div>`
        : ""
    }
                 ${
      product.tags.includes("Luxe Edit")
        ? `<div class="lebeltagtext z-1 tw-absolute tw-top-2 tw-left-2 tw-bg-blue-600 tw-text-white tw-text-xs tw-font-semibold tw-px-2 tw-py-1 tw-rounded" style="z-index:1; background:#028677; text-transform:uppercase; font-size:12px; margin-top:5px;">Luxe Edit</div>`
        : ""
    }
              <!-- Wishlist HTML -->
           <div class="hulk_wishList_wrapper tw-absolute tw-top-0 tw-right-0 tw-p-[0.5rem] tw-z-[1] tw-bg-white tw-rounded-[100%] tw-flex tw-justify-center tw-items-center tw-m-[1rem]">
             <a
               href="#"
               class="icon-wishlist-heart-empty wishlist-btn grid-wishlist-btn heart-wishlist-animation before:!tw-m-0"
               data-wishList
               data-added="false"
               data-proID="${product.id}"
               data-varID="${product.first_available_variant_id}"
               data-button-layout="${wishlistData.button_layout}"
               id="wishlist_btn">
               <div
                 class="hulk_wl_icon-text"
                 hulk-wl-custom-style
                 data-count="${wishlistData.public_wishlist_count}">
                 <div class="hulk_wl_icon">
                   <i class="heart-hulk-animation !tw-mr-0"><i class="icon-wishlist-heart-empty"></i></i>
                 </div>
               </div>
               ${
                 wishlistData.button_layout === 'multi_color_button' &&
                 (wishlistData.button_style === 'style_2' || wishlistData.button_style === 'style_4')
                   ? '<span class="count" hulk-wl-custom-style>0</span>'
                   : '<span class="count" hulk-wl-custom-style>(0)</span>'
               }
             </a>
           </div>
           <!-- End Wishlist HTML -->

              <a href=${product.url} class="media tw-pb-[115%] image-1">    
                <img src="${product.featured_image};width=1500" alt="${
          product.title
        }" srcset="${product.featured_image};width=165 165w, ${
          product.featured_image
        };width=360 360w, ${product.featured_image};width=535 535w, ${
          product.featured_image
        };width=750 750w, ${
          product.featured_image
        };width=1070 1070w" width="1500" height="1800" loading="lazy" class="image " sizes="(min-width: 1400px) 650px, (min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)">
              </a>
              
              <a href="${product.url}" class="media image-2 tw-pb-[115%]">    
                <img  src="${product.images[1]};width=1500" alt="${
          product.title
        }-" srcset="${product.images[1]};width=165 165w, ${
          product.images[1]
        };width=360 360w, ${product.images[1]};width=535 535w, ${
          product.images[1]
        };width=750 750w, ${
          product.images[1]
        };width=1070 1070w" width="1500" height="1800" loading="lazy" class="image " sizes="(min-width: 1400px) 650px, (min-width: 1200px) 550px, (min-width: 750px) calc((100vw - 130px) / 2), calc((100vw - 50px) / 2)">
              </a>
            </div>
          </popup-info>
          <div class="product-card__badges tw-absolute tw-top-0 tw-left-2 lg:tw-top-4 lg:tw-left-4"></div>
        </div>

        <div class="product-card__info">
          <a href="/products/${
            product.handle
          }" class="line-clamp-2 tw-text-center product-card__title tw-leading-normal lg:tw-mt-[12px] tw-mt-[5px] blg:tw-text-[12px] tw-font-semibold tw-no-underline">
            ${product.title}
          </a>

         ${
            product.product_type == null ? '':`    <div class="product-type-text tw-flex tw-justify-center tw-my-[10px] !tw-m-0">
            <p class="tw-font-ibm-r tw-font-semibold blg:tw-text-[1.2rem] md:tw-text-[1.6rem]">${ product.product_type }</p>
            </div>`
         }

          <div style='${product.jm_style || ""}' class='jdgm-widget jdgm-preview-badge' data-id='${product.id}' data-auto-install='false'>
            ${product.metafields.judgeme || ""}
          </div>
      
          <div id="price-${
            product.id
          }" class="product_price tw-flex tw-flex-wrap tw-items-baseline tw-justify-center tw-gap-4 md:tw-gap-4">`;

        productHtml += `<span class="h4 tw-font-bold tw-text-[12px] lg:tw-text-[18px] tw-text-red-500">
          ₹ ${
            product.first_available_variant_price
              ? product.first_available_variant_price / 100
              : product.price / 100
          }
          </span>`;

          if (product.compare_at_price > product.price) {
            productHtml += `
              <span class="tw-line-through tw-text-[12px] lg:tw-text-[18px]  ">
              ₹ ${
                product.first_available_variant_compare_at_price
                  ? product.first_available_variant_compare_at_price / 100
                  : product.compare_at_price / 100
              }
              </span>`;
          }

          if (product.compare_at_price > product.price) {
             productHtml += `<span class="h4 percent-count tw-text-[#ff6767] tw-text-[10px] lg:tw-text-[12px] tw-font-bold">
              (${
                product.first_available_variant_compare_at_price
                  ? (
                      ((product.first_available_variant_compare_at_price -
                        product.first_available_variant_price) /
                        product.first_available_variant_compare_at_price) *
                      100
                    ).toFixed(0)
                  : (
                      ((product.compare_at_price - product.price) /
                        product.compare_at_price) *
                      100
                    ).toFixed(0)
              }% Off)
            </span>`;
          } else {
            var discountHtml = ''; // Ensure it's an empty string if no discount
          }

        if (product.available) {
          productHtml += `     
          </div>
          <div class="product-buy-buttons tw-flex tw-gap-[2px] tw-justify-center">
            <product-form class="tw-w-1/2">
            <form method="post" action="/cart/add" id="mm-product-form--${product.id
            }" accept-charset="UTF-8" class="form" enctype="multipart/form-data" novalidate="novalidate" data-type="add-to-cart-form"><input type="hidden" name="form_type" value="product"><input type="hidden" name="utf8" value="✓"><input type="hidden" name="id" value="${product.first_available_variant_id ? product.first_available_variant_id : product.id
            }">
              <div class="product_buttons tw-px-2 tw-h-[3rem] lg:tw-h-[50px] lg:tw-flex sm:tw-justify-around lg:tw-mb-[8px] tw-gap-[11px]">

                <button id="mm-product-form--${product.id
            }-submit" type="submit" name="add" class="tw-bg-transparent quick-add__submit tw-relative tw-border tw-text-[1rem] lg:tw-h-[50px] tw-border-[#54555A] tw-h-[3.1rem] lg:tw-text-[15px] tw-font-[500] tw-rounded-[3px]  button--full-width quick-add__submit tw-cursor-pointer " aria-haspopup="dialog" aria-labelledby="mm-product-form--${product.id
            }-submit title--${product.id
            }" aria-live="polite" data-sold-out-message="true">`;

          productHtml += `<span class="tw-justify-center  tw-text-[#363636] tw-items-center tw-h-[3rem] lg:tw-h-[50px] tw-w-full tw-flex ">Add To Cart
                  </span>
                  `;
        }

        productHtml += `
                  <div class="loading-overlay__spinner hidden tw-absolute tw-left-[0] tw-top-[0] tw-w-full tw-h-full tw-flex tw-items-center tw-justify-center">
                    <svg height="20px" width="20px" aria-hidden="true" focusable="false" class="spinner tw-max-w-[20px] tw-max-h-[20px]" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                  </div>
                </button>
              </div>`;

        if (product.available) {
          productHtml += `<input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" ></form></product-form>
                         
                <button type="button" class="plp-gokwik-buy-now" onclick="onBuyNowClick(this,'#mm-product-form--${product.id}')" id="gokwik-buy-now">Buy Now
                    <div style="display:none" class="addloadr" id="btn-loader"><div class="cir-loader">Loading..</div></div>
                </button> `;
        }else{
          productHtml += `<input type="hidden" name="product-id" value="${product.id}"><input type="hidden" name="section-id" ></form></product-form>`
        }

        productHtml += `
            
          </div>
        </div>
      </marmeto-product-card>`;

        return productHtml;
      },
    };
  };
  return Collection;
})();

/*
 *  Must know :
    Collection.prototype.htmlRenderer
    Collection.prototype.initCustomFilters
 */
new products.Collection("marmeto-collection-template");
